import React, { Component, PropTypes } from 'react';
import './DownArrow.css';

class DownArrow extends Component {

  render() {
    let activeClass = '';
    if (!this.props.isActive) activeClass = 'downArrow__arrow';
    return (
      <div className="downArrow__close">
        <div className={`downArrow__close-left ${activeClass}`}></div>
        <div className={`downArrow__close-right ${activeClass}`}></div>
      </div>
    );
  }
}

DownArrow.propTypes = {
  isActive: PropTypes.bool.isRequired
};

export default DownArrow;



/** WEBPACK FOOTER **
 ** ./src/icons/DownArrow/index.js
 **/